import api from '../interceptors/axiosInterceptor'
import API_CONFIG from '../config'

const USER_ENDPOINTS = {
  PROFILE: '/users/profile',
  UPDATE_PROFILE: '/users/profile',
  CHANGE_PASSWORD: '/users/change-password',
  UPLOAD_AVATAR: '/users/avatar',
  GET_ALL: '/users',
  GET_BY_ID: '/users', 
  UPDATE: '/users',    
  DELETE: '/users',    
  ROLES: '/users/roles'
}

const UserService = {
  // تغییر رمز عبور
  async changePassword(passwordData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.CHANGE_PASSWORD}`,
        passwordData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // آپلود عکس پروفایل
  async uploadAvatar(formData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.UPLOAD_AVATAR}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت همه کاربران (مدیریت)
  async getAllUsers(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.GET_ALL}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت کاربر توسط ID
  async getUserById(userId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.GET_BY_ID}/${userId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی کاربر
  async updateUser(userId, userData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.UPDATE}/${userId}`,
        userData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف کاربر
  async deleteUser(userId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.DELETE}/${userId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت نقش‌های کاربر
  async getUserRoles() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${USER_ENDPOINTS.ROLES}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  handleError(error) {
    // مشابه هندل ارور در AuthService
    if (error.response) {
      return {
        message: error.response.data.message || 'خطای سرور رخ داده است',
        status: error.response.status,
        data: error.response.data
      }
    }
    // ...
  }
}

export default UserService